import { Col, Row, Skeleton, Space } from 'antd'

export default function SkeletonResultForm({
    labelSpan = 6,
    wrapperSpan = 18,
    showAttachments = true,
    attachmentThumbs = 1,
}) {
    return (
        <div style={{ borderRadius: 8 }}>
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                {/* Status (Select) */}
                <Row gutter={16} align="middle">
                    <Col span={labelSpan}>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 100 }}
                        />
                    </Col>
                    <Col span={wrapperSpan}>
                        <Skeleton.Input
                            active
                            style={{ width: '100%', height: 32 }}
                        />
                    </Col>
                </Row>

                {/* Comment (Textarea) */}
                <Row gutter={16}>
                    <Col span={labelSpan}>
                        <Skeleton.Input
                            active
                            size="small"
                            style={{ width: 100 }}
                        />
                    </Col>
                    <Col span={wrapperSpan}>
                        <Skeleton
                            active
                            paragraph={{ rows: 3 }}
                            title={false}
                        />
                    </Col>
                </Row>

                {/* Attachments */}
                {showAttachments && (
                    <Row gutter={16}>
                        <Col span={labelSpan}>
                            <Skeleton.Input
                                active
                                size="small"
                                style={{ width: 120 }}
                            />
                        </Col>
                        <Col span={wrapperSpan}>
                            <Space wrap size={8}>
                                {Array.from({ length: attachmentThumbs }).map(
                                    (_, i) => (
                                        <Skeleton.Image
                                            key={i}
                                            active
                                            style={{
                                                width: 96,
                                                height: 72,
                                                borderRadius: 8,
                                            }}
                                        />
                                    )
                                )}
                            </Space>
                        </Col>
                    </Row>
                )}

                {/* <Divider style={{ margin: '8px 0 0' }} /> */}

                {/* Footer actions */}
                <Row justify="end">
                    <Space size={12} style={{ marginTop: 16 }}>
                        <Skeleton.Button active style={{ width: 88 }} />
                        <Skeleton.Button active style={{ width: 88 }} />
                    </Space>
                </Row>
            </Space>
        </div>
    )
}
